import { useContext, useEffect } from 'react'

import { ToastContext } from '@reveni-io/reveni-ui'

import { getAvailableEmailVariables, getAvailableEmailVariablesSections } from '@/common/helpers/helpers'
import useAddImage from '@/common/hooks/useAddImage/useAddImage'
import useAddLink from '@/common/hooks/useAddLink/useAddLink'
import useAddVariable from '@/common/hooks/useAddVariable/useAddVariable'

const useEmailEditor = ({ onChange, merchantId, disabled, emailType }) => {
  const { setToastInfo } = useContext(ToastContext)
  const { editorRef, onAddVariable } = useAddVariable({ onChange })
  const { toolbarRef, showLinkPopup, openAddLinkPopup, onCloseLinkPopup, onAddLink } = useAddLink({
    editorRef,
    onChange,
  })
  const { onImageUpload, triggerImageUpload } = useAddImage({ merchantId, setToastInfo, editorRef })

  const availableVariables = getAvailableEmailVariables([emailType])
  const availableSections = getAvailableEmailVariablesSections([emailType])

  useEffect(() => {
    if (!editorRef.current) return
    if (disabled) {
      editorRef.current.disable()
    } else {
      editorRef.current.enable()
    }
  }, [disabled, editorRef])

  return {
    editorRef,
    toolbarRef,
    onAddVariable,
    showLinkPopup,
    openAddLinkPopup,
    onCloseLinkPopup,
    onAddLink,
    onImageUpload,
    triggerImageUpload,
    availableVariables,
    availableSections,
  }
}

export default useEmailEditor
